import Vue from 'vue';
import { mapGetters } from 'vuex';
import NetworkLayout from '../widgets/NetworkLayout.vue';
import DownloadExportButton from './DownloadExportButton.vue';
import HelpIcon from './HelpIcon.vue';
const MIN_CONCEPTS = 3; // minimum number of concepts to render the network
export default Vue.extend({
    components: {
        DownloadExportButton,
        HelpIcon,
        NetworkLayout
    },
    props: {
        clickableNodes: { type: Boolean, default: true },
        headerIcon: { type: Boolean, default: false },
        headerTools: { type: Boolean, default: true },
        height: { type: Number, default: 450 },
        model: { type: Object, default: null },
        noDataMsg: { type: String, default: 'Not enough data for network' },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            isNetworkDrawn: false,
            networkHelp: '<p>The context of a query is depicted in this visualization. It shows all of the terms that have a meaningful relationship with the terms or concepts in your query and the strength of the relationship between them. If your query doesn\'t contain any terms or concepts, the network will simply show the most frequent terms and concepts from the query results.</p>' +
                '<p>Concepts from your query will appear in their storyboard color. Terms from your query will appear in light grey. Circle sizes are based on the frequency of that term/concept. Clicking on a term/concept will add it to the query.</p>' +
                '<p>The lines linking nodes indicate a relationship between the terms. The thicker the line linking two nodes the stronger the relationship between those two terms. If there is no line linking two terms, then the relationship between those two terms is too weak to consider or there is no relationship.</p>' +
                '<p>By default, not all lines are drawn. Instead, only the thickest lines are drawn to connect every node. Hover a node to see all of its relationships.</p>',
        };
    },
    computed: {
        isInsufficientData() {
            const len = this.model?.concepts?.length || 0;
            return len < MIN_CONCEPTS;
        },
        ...mapGetters(['currentAnalysis', 'currentDashboard'])
    },
    watch: {
        model: function () {
            // reset state after underlying data changes
            this.isNetworkDrawn = false;
        }
    },
    methods: {
        getExportConfig() {
            return this.$refs.networkLayout.getExportConfig();
        },
        getNetworkEl() {
            return this.$el.querySelector('.network-wrapper svg');
        }
    }
});
